import { isEmpty, xor } from 'lodash';

export const insertAt = <T>(array: T[], index: number, item: T): T[] => [...array.slice(0, index), item, ...array.slice(index)];

export const convertToMap = <T extends Record<never, never>>(arr: T[], key: keyof T): Record<string, T> => {
  return arr.reduce((acc, item) => {
    acc[item[key] as unknown as string] = item;
    return acc;
  }, {} as Record<string, T>);
};

export const areArraysEqual = <T>(array1: T[], array2: T[]): boolean => isEmpty(xor(array1, array2));

/**
 * Shuffles an array of prompts using the Fisher-Yates algorithm.
 *
 * @param prompts - The array of prompts to shuffle.
 * @returns A new array with the prompts shuffled.
 */
export const shuffleArray = (prompts: string[]): string[] => {
  const shuffled = [...prompts]; // Create a copy to avoid mutating the original array
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1)); // Random index from 0 to i
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // Swap elements
  }
  return shuffled;
};
